import styled from '@emotion/styled'

const RelatedArticlesSwiperWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

export default RelatedArticlesSwiperWrapper